export default __webpack_public_path__ + "organization.038d18b57614cc718825.svg";